<div class="p-4 pl-5 pt-5">
  <img src="assets/images/file-stars.svg" />
  <div class="text-bold text-xxl mt-3" i18n>Unlock AI Review insights</div>
  <div class="text-light3 text-semi-bold text-sm" i18n>
    Get AI-powered tips to improve your property and increase revenue
  </div>
  <div class="mt-4">
    <div class="text-bold text-sm mb-1" i18n>What you'll get</div>
    <div class="d-flex flex-column gap-1 text-sm text-light3">
      <div>
        <i class="cs-icon cs-icon-check2 text-success2 text-xxs"></i> &nbsp;
        <ng-container i18n>Summary of guest sentiments</ng-container>
      </div>
      <div>
        <i class="cs-icon cs-icon-check2 text-success2 text-xxs"></i> &nbsp;
        <ng-container i18n>Suggestions to improve your listing</ng-container>
      </div>
      <div>
        <i class="cs-icon cs-icon-check2 text-success2 text-xxs"></i> &nbsp;
        <ng-container i18n>Insights to boost 5-star reviews</ng-container>
      </div>
      <div>
        <i class="cs-icon cs-icon-check2 text-success2 text-xxs"></i> &nbsp;
        <ng-container i18n>Revenue opportunities from real guest feedback</ng-container>
      </div>
    </div>
  </div>

  <div class="p-4 d-flex align-items-center gap-3 bg-primary-light rounded mt-4">
    <div
      class="text-primary bg-white rounded-circle d-flex align-items-center justify-content-center border-primary"
      style="width: 30px; height: 30px; border-width: 0.5px !important"
    >
      <i class="cs-icon cs-icon-light-stars text-lg"></i>
    </div>
    <div class="flex-fill text-semi-bold text-sm">
      <div class="" i18n>Greeted with fresh coffee, great host</div>
      <div class="text-warning2" i18n>— but wish we had more bathroom lighting.</div>
    </div>
  </div>
  <div class="position-relative">
    <img src="assets/images/line-arrow.svg" class="position-absolute" style="top: -20px; left: -20px" />
    <div class="text-light3 text-sm ml-4 mt-1" i18n>
      We’ll turn reviews like this into actionable insights for your success.
    </div>
  </div>
  <div class="mt-5">
    <div class="text-light3 text-sm" i18n>Enable AI now to get smart suggestions from every review.</div>
    <button class="btn btn-secondary-info mt-1" (click)="onEnableAI()">
      <i class="cs-icon cs-icon-file-chart-stars text-lg"></i>
      <ng-container i18n>Unlock AI Review insights</ng-container>
    </button>
  </div>
</div>
